// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__BAVgB","upload":"Small_upload__3hcW2","imageWrap":"Small_imageWrap__3kdno","removeBtn":"Small_removeBtn__1bC8X"};